import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import logo from 'resources/Fedex-logo.png';

const styles = {
  logo: {
    height: '35px'
  },
  accountList: {
    display: 'flex',
    alignItems: 'center',
    color: 'gray',
    paddingTop: '15px',
    fontSize: '16px',
    fontWeight: 300
  },
  accountSpan: {
    paddingRight: '10px'
  }
};

export const UnstyledCarrierAccounts = ({
  data, classes
}) => (
  <div className="CCP__CarrierAccounts__base">
    { data != null && data.length
      && (
        <div className="CCP__CarrierAccounts__accounts-list">
          <img className={ classes.logo } src={ logo } alt="FedEx logo" />
          { data.slice(0, 3).map(account => (
            <div className={ `CCP__CarrierAccount_account ${classes.accountList}` } key={ account }>
              <span className={ classes.accountSpan }>{account}</span>
            </div>
          ))}
        </div>
      )
    }
  </div>
);

UnstyledCarrierAccounts.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.array,
};

UnstyledCarrierAccounts.defaultProps = {
  data: null
};

export default withStyles(styles)(UnstyledCarrierAccounts);
